<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { SelectSearch } from '@shared/ui/fields'

import { useTutorKanbanSelectPriority } from '../../model/use-tutor-kanban-select-priority.hook'

defineOptions({
  name: 'TutorKanbanSelectPriority',
})

const {
  refOptions,
  refCurrent,
  handleChange,
} = useTutorKanbanSelectPriority()
</script>

<template>
  <RowSlot label="Priority">
    <SelectSearch
      id="tutor-kanban-priority"
      placeholder="Select priority"
      :options="refOptions"
      :value="refCurrent"
      @change="handleChange"
    />
  </RowSlot>
</template>

<style scoped lang="scss" src="./TutorKanbanSelectPriority.scss" />